module.exports = __webpack_public_path__ + "img/贵州大学.a6c2cf24.png";